import React from 'react'
import { ProgettiNode } from '@gql/graphql'
import useTrans from '@hooks/useTrans'
import { GenericSectionThemeType, MenuItemType } from '@utils/types'
import { GenericCardSwiper } from '@components/organisms'
import styles from './ProgettiSection.module.sass'
import useTransRoute from '@hooks/useTransRoute'
import { appendQuery } from '@utils/index'

interface Props {
  refId?: string
  progetti?: ProgettiNode[] // TODO
  item?: MenuItemType
  theme?: GenericSectionThemeType
  className?: string
  idBrand?: any
}

const ProgettiSection = (props: Props) => {
  const {
    refId = undefined,
    progetti = [],
    item = undefined,
    theme = undefined,
    className = '',
    idBrand = undefined
  } = props

  const t = useTrans()
  const tRoute = useTransRoute()

  return progetti?.length ? (
    <GenericCardSwiper
      id="progetti-swiper"
      refId={refId}
      item={{
        name: t('Progetti'),
        ctaLabel: t('Tutti i progetti'),
        url: appendQuery(tRoute('/progetti')?.href, { brand: idBrand }),
        ...(item || {}), // Override
        children: progetti.map((i) => ({
          pk: i.slug,
          name: i.title,
          image: i.imageUrl,
          imageAle: i.imageAlt,
          tag: i.destinazioneTitolo,
          url: i.url,
        })),
      }}
      theme={theme}
      className={`${styles.root} ${className}`}
    />
  ) : (
    <></>
  )
}

export default ProgettiSection
